/**
 * 系统设置 - Webhooks 页：NOT-in-scope 占位页。
 * 后端无 webhooks 域契约与端点（§五），仅渲染分区标题 + NOT-in-scope 提示。
 */
import { NotInScopeNotice, SectionHead } from './settings-shared';

// ---------- Webhooks（NOT-in-scope：后端无 webhooks 域，§五）----------
export default function WebhooksPage() {
  return (
    <>
      <SectionHead title="Webhooks" sub="订阅运营事件 · 实时推送到你的端点" />
      <NotInScopeNotice text="Webhooks 的新建 / 编辑 / 删除 / 测试发送 / 轮换密钥 / 重试投递 dev-docs 均无对应契约与端点。详见 docs/plans §五。" />
    </>
  );
}
